;(() => {
  const productGridId = 'products-grid'
  const productFilterFormId = 'products-filters-form'
  const minPriceKey = 'filter.v.price.gte'
  const maxPriceKey = 'filter.v.price.lte'
  const filterDrawerToggle = document.getElementById('products-filters-toggle')

  //only run when products grid is on page
  if (!document.getElementById(productGridId)) return null

  if (filterDrawerToggle) {
    const filterDrawer = document.getElementById('products-filters')
    const toggleFilterDrawer = (isOpen) => {
      filterDrawer.classList.toggle('open', isOpen)
      document.body.classList.toggle('menu-open', isOpen)
    }

    filterDrawerToggle.addEventListener('click', () => toggleFilterDrawer(true))

    document
      .querySelectorAll('.products-filters-close, #filters-background')
      .forEach((element) => {
        element.addEventListener('click', () => toggleFilterDrawer(false))
      })
  }

  function bindDropdownToggles() {
    const filterDropdowns = document.querySelectorAll(
      `#${productFilterFormId} .filter-dropdown-toggle`
    )
    filterDropdowns.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        toggle.classList.toggle('active')
        const dropdown = toggle.closest(
          'header.filter-dropdown-header'
        ).nextElementSibling
        if (dropdown.style.height) {
          dropdown.style.height = null
        } else {
          dropdown.style.height = dropdown.scrollHeight + 'px'
        }
      })
    })
  }

  bindDropdownToggles()

  async function updateProductsAndFilters(url) {
    try {
      const response = await fetch(url)
      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const newProductGrid = doc.getElementById(productGridId)
      const newFilters = doc.getElementById(productFilterFormId)

      //update url
      const urlObject = new URL(url, window.location.origin)
      urlObject.searchParams.delete('section_id')
      const urlWithoutSection = urlObject.toString()
      history.pushState(null, '', urlWithoutSection)

      if (newProductGrid) {
        document.getElementById(productGridId).innerHTML =
          newProductGrid.innerHTML
      }

      if (newFilters) {
        document.getElementById(productFilterFormId).innerHTML =
          newFilters.innerHTML
        bindDropdownToggles()
        bindClearFilters()
      }
    } catch (error) {
      console.error('error fetching products', error)
      if (window.Sentry) {
        Sentry.captureException(error, { tags: { function: 'fetchProducts' } })
      }
    }
  }

  function updateUI(formElement, urlToUse) {
    const formData = new FormData(formElement)
    const searchParams = new URLSearchParams(formData)

    //preserve search query from url
    const query = new URLSearchParams(window.location.search).get('q')
    if (query) {
      searchParams.set('q', query)
    }

    searchParams.set('section_id', 'products')

    const sortBy = new URLSearchParams(window.location.search).get('sort_by')
    if (sortBy) {
      searchParams.append('sort_by', sortBy)
    }

    //filter out min/max price if not set or if set to defaults
    if (
      !formData.get(minPriceKey) ||
      Number(formData.get(minPriceKey)) <= window.collectionMinPrice
    ) {
      searchParams.delete(minPriceKey)
    }

    if (
      !formData.get(maxPriceKey) ||
      Number(formData.get(maxPriceKey)) >= window.collectionMaxPrice
    ) {
      searchParams.delete(maxPriceKey)
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`
    const url = urlToUse || newUrl

    updateProductsAndFilters(url)
  }

  function updateSort(value) {
    const url = new URL(window.location)
    url.searchParams.set('sort_by', value)
    const urlString = url.toString()
    updateProductsAndFilters(urlString)
  }

  function bindFilterEvents() {
    const filterForm = document.getElementById(productFilterFormId)
    const sortSelect = document.getElementById('sort-products-by')
    filterForm.addEventListener('change', () => updateUI(filterForm))
    sortSelect.addEventListener('change', (event) => {
      updateSort(event.target.value)
    })
  }

  function bindClearFilters() {
    const filterForm = document.getElementById(productFilterFormId)
    filterForm
      .querySelectorAll('button.clear-filter[data-url-to-remove]')
      .forEach((button) => {
        button.addEventListener('click', () =>
          updateUI(filterForm, button.getAttribute('data-url-to-remove'))
        )
      })
  }

  bindFilterEvents()
  bindClearFilters()

  document
    .querySelector('#products-filters-clear-all')
    .addEventListener('click', function () {
      const newSearchParams = new URLSearchParams()

      const query = new URLSearchParams(window.location.search).get('q')
      if (query) {
        newSearchParams.set('q', query)
      }

      newSearchParams.set('section_id', 'products')

      const url = `${window.location.pathname}?${newSearchParams.toString()}`
      updateProductsAndFilters(url)
    })
})()
